import React, { lazy } from 'react';
import logo from './logo.svg';
import './App.css';

import { PersonalInsurance } from './Components/PersonalInsurance';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { NavigationBar } from './Components/NavigationBar';
import { HomePage } from './Components/HomePage';
import { Footer } from './Components/Footer';
import { CommercialInsurance } from './Components/CommercialBusinessInsurance';
import ArticlesPage from './Components/Articles';
import { MedicalMalpractice } from './Components/MedicalMalpractice';
import { HealthInsurance } from './Components/HealthInsurance';
import { LifeAndInvestment } from './Components/LifeAndInvestments';
import { ContactUs } from './Components/ContactUs';
import { SpecialRisks } from './Components/SpecialRisks';
import LegalInformation from './Components/LegalInformation';
import { CyberRiskDisclaimer } from './Components/CyberRisk';
import ReactGA from 'react-ga4';
import { NotFound } from './Components/NotFound';


function App() {
  ReactGA.initialize('G-ECGH6LJ63Y');
  return (
    //<PersonalInsurance/>

    <BrowserRouter>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/PersonalInsurance" element={<PersonalInsurance />} />
        <Route path='/CommercialBusinessInsurance' element={<CommercialInsurance />} />
        <Route path='/MedicalMalpractice' element={<MedicalMalpractice />} />
        <Route path='/HealthInsurance' element={<HealthInsurance />} />
        <Route path='/LifeAndInvestment' element={<LifeAndInvestment />} />
        <Route path='/Articles' element={<ArticlesPage />} />
        <Route path='/ContactUs' element={<ContactUs />} />
        <Route path='/SpecialRisk' element={<SpecialRisks />} />
        <Route path='/LegalInformation' element={<LegalInformation />} />
        <Route path='/CyberRiskDisclaimer' element={<CyberRiskDisclaimer />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />

    </BrowserRouter>

  );
}

export default App;
